import { Directive, ElementRef, Renderer, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Directive ({
  selector: '[status]'
})
export class StatusDirective implements OnInit {

  @Input() val: number;

  constructor (
    private _eleRef: ElementRef,
    private _renderer: Renderer
  ) { }

  ngOnInit () {
    this.setStatus(this.val);
  }

  private setStatus (_ref: number=0) {
    if (_ref == 1) {
      this._renderer.setElementClass(this._eleRef.nativeElement, "text-success", true);
    } else {
      this._renderer.setElementClass(this._eleRef.nativeElement, "text-danger", true);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/directives/status.directive.ts